// Author YuJiaBei
// Date 2023-11-02 21:34:35

class EmAclUser {
constructor({
        id = null,
        sid = '',
        loginName = '',
        openId = '',
        name = '',
        sex = '',
        cardid = '',
                education = '',
                userTypeId = '',
                telephone = '',
                mail = '',
                employeeId = '',
                password = '',
                deptId = '',
                status = '',
                enablestate = '',
                description = '',
                passwordUpdatedTime = '',
                userGroupId = ''
            }
= {}) {
    this.id = id;
    this.sid = sid;
    this.loginName = loginName;
    this.openId = openId;
    this.name = name;
    this.sex = sex;
    this.cardid = cardid;
    this.education = education;
    this.userTypeId = userTypeId;
    this.telephone = telephone;
    this.mail = mail;
    this.employeeId = employeeId;
    this.password = password;
    this.deptId = deptId;
    this.status = status;
    this.enablestate = enablestate;
    this.description = description;
    this.passwordUpdatedTime = passwordUpdatedTime;
    this.userGroupId = userGroupId;
}
}

function newEntity() {
return new EmAclUser();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'loginName',
        label: 'label.em.admin.emAclUser.grid.loginName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'name',
        label: 'label.em.admin.emAclUser.grid.name',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'sex',
        label: 'label.em.admin.emAclUser.grid.sex',
        sortable: true,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
        ,options: [
                { value: '1', text: '男' },
                            { value: '2', text: '女' }
            ]
        }
        },
        {
        key: 'userTypeId',
        label: 'label.em.admin.emAclUser.grid.userTypeId',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'telephone',
        label: 'label.em.admin.emAclUser.grid.telephone',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'employeeId',
        label: 'label.em.admin.emAclUser.grid.employeeId',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'deptName',
        label: 'label.em.admin.emAclUser.grid.deptName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'status',
        label: 'label.em.admin.emAclUser.grid.status',
        sortable: true,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
        ,options: [
                { value: '1', text: '在职' },
                            { value: '2', text: '离职' },
                            { value: '3', text: '删除' }
            ]
        }
        },
        {
        key: 'enablestate',
        label: 'label.em.admin.emAclUser.grid.enablestate',
        sortable: true,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
        ,options: [
                { value: '1', text: '未启用' },
                            { value: '2', text: '已启用' },
                            { value: '3', text: '已停用' }
            ]
        }
        },
        {
        key: 'description',
        label: 'label.em.admin.emAclUser.grid.description',
        sortable: true,
            isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
            key: 'passwordUpdatedTime',
            label: 'label.em.admin.emAclUser.grid.passwordUpdatedTime',
            sortable: true,
            form: {
                type: 'datetimepicker',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'userGroupName',
            label: 'label.em.admin.emAclUser.grid.userGroupName',
            sortable: true,
            form: {
                type: 'input',
                linkTo: 'common_link',
                modalMultiSelectedType: 'string'
            }
        }
    ])}

const filter = {
    idFilter : '',
    sidFilter : '',
    idListFilter : [],
    deptNodeCodeStartsWithFilter : '',
    loginNameFilter : '',
    loginNameInFilter : [],
    openIdFilter : '',
    loginNameEqFilter : '',
    nameFilter : '',
    sexFilter : '',
    cardidFilter : '',
    educationFilter : '',
    userTypeIdFilter : '',
    telephoneFilter: '',
    mailFilter: '',
    employeeIdFilter: '',
    deptIdInFilter: [],
    deptIdFilter: '',
    statusFilter: '',
    enablestateFilter: '',
    emAclDeptIdFilter: '',
    emAclDeptNodeCodeFilter: '',
    passwordUpdatedTimeRteFilter: '',
    passwordUpdatedTimeLteFilter: '',
    userGroupIdFilter: '',
    userGroupNameFilter: ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'sidFilter',
        label: 'label.em.admin.emAclUser.filter.sid',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'loginNameFilter',
        label: 'label.em.admin.emAclUser.filter.loginName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'openIdFilter',
        label: 'label.em.admin.emAclUser.filter.openId',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'nameFilter',
        label: 'label.em.admin.emAclUser.filter.name',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'sexFilter',
        label: 'label.em.admin.emAclUser.filter.sex',
        disabled: false,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
            ,showLabelSelectOne: true
         ,options: [
                { value: '1', text: '男' },
                { value: '2', text: '女' }
            ]
        }
        },
        {
        key: 'cardidFilter',
        label: 'label.em.admin.emAclUser.filter.cardid',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'educationFilter',
        label: 'label.em.admin.emAclUser.filter.education',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'userTypeIdFilter',
        label: 'label.em.admin.emAclUser.filter.userTypeId',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'telephoneFilter',
        label: 'label.em.admin.emAclUser.filter.telephone',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mailFilter',
        label: 'label.em.admin.emAclUser.filter.mail',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'employeeIdFilter',
        label: 'label.em.admin.emAclUser.filter.employeeId',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'deptIdFilter',
        label: 'label.em.admin.emAclUser.filter.deptId',
        disabled: false,
        form: {
        type: 'treeSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emAclDept'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'statusFilter',
        label: 'label.em.admin.emAclUser.filter.status',
        disabled: false,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
            ,showLabelSelectOne: true
         ,options: [
                { value: '1', text: '在职' },
                { value: '2', text: '离职' },
                { value: '3', text: '删除' }
            ]
        }
        },
        {
        key: 'enablestateFilter',
        label: 'label.em.admin.emAclUser.filter.enablestate',
        disabled: false,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
            ,showLabelSelectOne: true
         ,options: [
                { value: '1', text: '未启用' },
                { value: '2', text: '已启用' },
                { value: '3', text: '已停用' }
            ]
        }
        },
        {
        key: 'passwordUpdatedTimeRteFilter',
        label: 'label.em.admin.emAclUser.filter.passwordUpdatedTimeRte',
        disabled: false,
        form: {
        type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
        },
    {
        key: 'passwordUpdatedTimeLteFilter',
        label: 'label.em.admin.emAclUser.filter.passwordUpdatedTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'userGroupIdFilter',
        label: 'label.em.admin.emAclUser.filter.userGroupId',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'userGroupNameFilter',
        label: 'label.em.admin.emAclUser.filter.userGroupName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    }
];


    const entityFormConfigs = [
        {
        key: 'sid',
        label: 'label.em.admin.emAclUser.entity.sid',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'loginName',
        label: 'label.em.admin.emAclUser.entity.loginName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'openId',
        label: 'label.em.admin.emAclUser.entity.openId',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'name',
        label: 'label.em.admin.emAclUser.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
            ,required: true
                }
        },
        {
        key: 'sex',
        label: 'label.em.admin.emAclUser.entity.sex',
        sortable: true,
        disabled: false,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
            ,showLabelSelectOne: true
        ,options: [
                { value: '1', text: '男' },
                { value: '2', text: '女' }
            ]
        }
        },
        {
        key: 'cardid',
        label: 'label.em.admin.emAclUser.entity.cardid',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'education',
        label: 'label.em.admin.emAclUser.entity.education',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'userTypeId',
        label: 'label.em.admin.emAclUser.entity.userTypeId',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'telephone',
        label: 'label.em.admin.emAclUser.entity.telephone',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mail',
        label: 'label.em.admin.emAclUser.entity.mail',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'employeeId',
        label: 'label.em.admin.emAclUser.entity.employeeId',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
            ,required: true
                }
        },
        {
        key: 'password',
        label: 'label.em.admin.emAclUser.entity.password',
        sortable: true,
        disabled: false,
        form: {
        type: 'password',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'deptId',
        label: 'label.em.admin.emAclUser.entity.deptId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,required: true
            ,entity: 'emAclDept'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'status',
        label: 'label.em.admin.emAclUser.entity.status',
        sortable: true,
        disabled: false,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
            ,showLabelSelectOne: true
        ,options: [
                { value: '1', text: '在职' },
                { value: '2', text: '离职' },
                { value: '3', text: '删除' }
            ]
        }
        },
        {
        key: 'enablestate',
        label: 'label.em.admin.emAclUser.entity.enablestate',
        sortable: true,
        disabled: false,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
            ,showLabelSelectOne: true
        ,options: [
                { value: '1', text: '未启用' },
                { value: '2', text: '已启用' },
                { value: '3', text: '已停用' }
            ]
        }
        },
        {
            key: 'description',
            label: 'label.em.admin.emAclUser.entity.description',
            sortable: true,
            disabled: false,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'userGroupId',
            label: 'label.em.admin.emAclUser.entity.userGroupId',
            sortable: true,
            disabled: false,
            form: {
                type: 'entityModalSelect',
                modalMultiSelectedType: 'string'
                , entity: 'emEmAdmUserGroup'
                , correspondingField: 'id'
            }
        }
    ]

export {EmAclUser, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
